import { createSlice } from '@reduxjs/toolkit';

const calendarSlice = createSlice({
   name: 'calendarData',
   initialState: {
      activeMeetLink: '',
   },
   reducers: {
      setActiveMeetLink: (state, action) => {
         state.activeMeetLink = action.payload;
      },
      clearActiveMeetLink: state => {
         state.activeMeetLink = '';
      },
   },
});

export const { setActiveMeetLink, clearActiveMeetLink } = calendarSlice.actions;
export const calendarReducer = calendarSlice.reducer;
export const selectActiveMeetLink = state => state.calendarData?.activeMeetLink || '';
